var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavMenuExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.35 6.875a.938.938 0 0 1 1.326 0l2.462 2.462a.939.939 0 0 1 0 1.326l-2.462 2.462A.938.938 0 0 1 10.35 11.8l1.8-1.8-1.8-1.8a.937.937 0 0 1 0-1.325Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.25 1.25A3.75 3.75 0 0 1 20 5v10l-.005.193a3.75 3.75 0 0 1-3.745 3.557H3.75l-.193-.005a3.75 3.75 0 0 1-3.552-3.552L0 15V5a3.75 3.75 0 0 1 3.75-3.75h12.5ZM3.75 3.125c-1.036 0-1.875.84-1.875 1.875v10c0 1.035.84 1.875 1.875 1.875H5V3.125H3.75Zm3.125 13.75h9.375c1.035 0 1.875-.84 1.875-1.875V5c0-1.036-.84-1.875-1.875-1.875H6.875v13.75Z",
  clipRule: "evenodd"
})));
SvgNavMenuExpand.displayName = "SvgNavMenuExpand";
export { SvgNavMenuExpand as ReactComponent };
export default SvgNavMenuExpand;